import { render, staticRenderFns } from "./WindControlBanList.vue?vue&type=template&id=0bda0422&"
import script from "./WindControlBanList.vue?vue&type=script&lang=js&"
export * from "./WindControlBanList.vue?vue&type=script&lang=js&"
import style0 from "./WindControlBanList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports